import AccountType from "../enums/number-type.enum";
import Page from "../constants/page.enum";
import { AppConstant } from "../constants/app.constant";
import { NativeBridge } from "./native-bridge";
import { Routes } from "../constants/route.constant";
import Config from "../config/config"

export default class UtilService {
    static getAllQueryParams(allParamsString) {
        var vars = {};
        var parts = allParamsString.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }

    static getQueryParamValue(param, allParamsString) {
        var queryParameter = null;
        if (allParamsString.indexOf(param) > -1) {
            queryParameter = this.getAllQueryParams(allParamsString)[param];
            if (queryParameter === '') {
                queryParameter = null;
            }
        }
        return queryParameter;
    }

    static getPrimaryNumberFromAppLoginInfo(appLoginInfo) {
        appLoginInfo = appLoginInfo.data;
        return (appLoginInfo && appLoginInfo.userProfile && appLoginInfo.userProfile.userAuthToken && appLoginInfo.userProfile.userAuthToken.primaryMsisdn) ? appLoginInfo.userProfile.userAuthToken.primaryMsisdn : null;
    }

    static getSelectedNumberForApp() {
        // const selectedAccountType = this.getQueryParamValue("acctype", window.location.href);
        const selectedRTN = this.getQueryParamValue("accvalue", window.location.href);
        // if (selectedAccountType === 'postpaid' || selectedAccountType === 'prepaid' || ) {
        return selectedRTN;
        // }
        // return null;
    }

    static getSelectedAccTypeForApp() {
        let accType = this.getQueryParamValue("acctype", window.location.href);
        accType = accType.toLowerCase();
        switch (true) {
            case accType.indexOf('postpaid') > -1:
                return AccountType.POSTPAID;
            case accType.indexOf('prepaid') > -1:
                return AccountType.PREPAID;
            case accType.indexOf('fixed_line') > -1:
                return AccountType.FIXED_LINE;
            default:
                return null;
        }
    }

    static getPageForApp() {
        let page = this.getQueryParamValue("page", window.location.href);
        page = page.toLowerCase();
        switch (true) {
            case page.indexOf('dndregistration') > -1:
                return Page.REGISTRATION_FORM;
            case page.indexOf('dndcomplaint') > -1:
                return Page.COMPLAINT_FORM;
            default:
                return null;
        }
    }

    static isMobileApp() {
        return (((typeof MyAirtelAppReact) !== 'undefined') || (window.webkit !== undefined));
    }

    static isIOSWebview() {
        if (this.isMobileApp() && this.getMobilePlatform().iOS()) {
            return true;
        }
        return false;
    }

    static isIOSMsite() {
        if (!this.isMobileApp() && this.getMobilePlatform().iOS()) {
            return true;
        }
        return false;
    }

    static isAndroidMsite() {
        if (!this.isMobileApp() && this.getMobilePlatform().Android()) {
            return true;
        }
        return false;
    }

    static isAndroidWebview() {
        if (this.isMobileApp() && this.getMobilePlatform().Android()) {
            return true;
        }
        return false;
    }

    static isOtherMsite() {
        if (!this.isMobileApp() && this.getMobilePlatform().any() && !this.getMobilePlatform().Android() && !this.getMobilePlatform().iOS()) {
            return true;
        }
        return false;
    }

    static getMobilePlatform() {
        const mobileCheck = {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (mobileCheck.Android() || mobileCheck.BlackBerry() || mobileCheck.iOS() || mobileCheck.Opera() || mobileCheck.Windows());
            }
        };
        return mobileCheck;
    }

    static closeCurrentMobileWindow() {
        if (UtilService.isMobileApp() && window.MyAirtelAppReact) {
            window.MyAirtelAppReact.close();
        } else if(UtilService.isIOSWebview() && window.webkit) {
            let payload = NativeBridge.generatePayload(AppConstant.CLOSE_EVENT)
            window.webkit.messageHandlers.triggerAppEvent.postMessage(payload)
        }
    }

    static isMobile() {
        return this.getMobilePlatform().any() ? true : false;
    }

    static getPlatformInfo() {
        console.log("getPlatformInfo", navigator.userAgent);
    }

    static getChannelName() {
        if (this.isMobileApp()) {
            return "APP";
        }
        else if (this.isMobile()) {

            return "WAP";
        }
        else {
            return "WEB";
        }
    }

    static getFullUrl(urlParts) {
        let updatedUrlParts = null;
        if (urlParts && Array.isArray(urlParts)) {
            updatedUrlParts = urlParts.map((value, index) => {
                if (value.indexOf('/') === 0 && index > 0) {
                    value = value.substring(1);
                }
                if (value.substring(value.length - 1) === '/') {
                    value = value.substring(0, value.length - 1);
                }
                return value;
            })
            return updatedUrlParts.join('/');
        }
        return '';
    }

    static isPlatformWindows() {
        const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
        const platform = window.navigator.platform;
        if (windowsPlatforms.indexOf(platform) !== -1) {
            return true
        }
        else {
            return false
        }
    }

    static filterArraySize(arr, limit) {
        if (arr && Array.isArray(arr)) {
            if (!limit || isNaN(limit)) {
                limit = arr.length;
            }
            return arr.slice(0, limit);
        }
    }

    static isResponseContentTypeHtml(response) {
        if (response && response.headers && response.headers['content-type']) {
            if (response.headers['content-type'].indexOf('text/html') !== -1) {
                return true;
            }
            return false;
        }
        return false;
    }

    static checkNumberValidationWithLength(event, length) {
        if (event.which !== 8 && event.which !== 0 && (event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
        if (event.currentTarget.value.length > length && event.which !== 13) {
            event.preventDefault();
        }
    }

    static scrollToTop() {
        window.scrollTo(0, 0);
    }

    static checkIfConsentPage = () => {
        const path = window.location.pathname
        return path && String(path).includes(Routes.CONSENT)
    }

    static getStaticAssetsBasePath = () => {
        const path = Config && Config.staticAssetsBasePath ? Config.staticAssetsBasePath: ""
        return path
    }

    static checkIfNetworkError = (error) => {
        return !error || !error.response
    }

    // get App Name from Route for sentry
    static getAppName = () => {
        const path = window.location.pathname
        let appName = ""
        for (let key in Routes) {
            const route = Routes[key]
            //get current route
            if (route && path.includes(route)) {
                appName = String(route)
                break
            }
        }
        appName = appName.replace("/", "")
        appName = appName.toUpperCase()
        return appName
    }

}